import styles from "./styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import DiscountPercentageIcon from "../../assets/discount-percentage.svg";

export default function SalesBanner() {
  const translate = useTranslate(useLocaleProvider());
  return (
    <div className={styles.container}>
      <DiscountPercentageIcon
        alt={translate("ourapps_banner_percentage_icon_alt_text")}
      />
      <div className={styles.title}>
        <h2>{translate("ourapps_banner_title")}</h2>
      </div>
      <p>{translate("ourapps_banner_subtitle")}</p>
    </div>
  );
}
